import React from 'react';
import styled, { keyframes } from 'styled-components';
import { motion } from 'framer-motion';

const Wave = () => {
    return (
        <BackgroundEffect>
            {/* Floating orbs */}
            <Orb
                size="300px"
                color="rgba(155, 89, 182, 0.15)"
                top="10%"
                left="80%"
                duration={20}
            />
            <Orb
                size="200px"
                color="rgba(231, 76, 60, 0.1)"
                top="60%"
                left="10%"
                duration={25}
            />
            <Orb
                size="150px"
                color="rgba(155, 89, 182, 0.12)"
                top="30%"
                left="50%"
                duration={18}
            />
            <Orb
                size="100px"
                color="rgba(231, 76, 60, 0.08)"
                top="80%"
                left="70%"
                duration={22}
            />

            {/* Animated lines */}
            <LineSvg
                viewBox="0 0 1440 363"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <motion.path
                    initial={{ pathLength: 0, pathOffset: 1 }}
                    animate={{ pathLength: 1, pathOffset: 0 }}
                    transition={{ duration: 2, ease: "easeInOut" }}
                    d="M0 200 Q 360 100, 720 200 T 1440 200"
                    stroke="url(#gradient1)"
                    strokeOpacity="0.3"
                    strokeWidth="2"
                    fill="none"
                />
                <motion.path
                    initial={{ pathLength: 0, pathOffset: 1 }}
                    animate={{ pathLength: 1, pathOffset: 0 }}
                    transition={{ duration: 2.5, ease: "easeInOut", delay: 0.3 }}
                    d="M0 250 Q 360 150, 720 250 T 1440 250"
                    stroke="url(#gradient2)"
                    strokeOpacity="0.2"
                    strokeWidth="2"
                    fill="none"
                />
                <defs>
                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#9b59b6" />
                        <stop offset="100%" stopColor="#e74c3c" />
                    </linearGradient>
                    <linearGradient id="gradient2" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#e74c3c" />
                        <stop offset="100%" stopColor="#9b59b6" />
                    </linearGradient>
                </defs>
            </LineSvg>

            {/* Particle dots */}
            {[...Array(15)].map((_, i) => (
                <Particle
                    key={i}
                    style={{
                        top: `${Math.random() * 100}%`,
                        left: `${Math.random() * 100}%`,
                        animationDelay: `${Math.random() * 5}s`,
                        animationDuration: `${3 + Math.random() * 4}s`
                    }}
                />
            ))}
        </BackgroundEffect>
    );
};

const float = keyframes`
    0%, 100% {
        transform: translateY(0) translateX(0);
    }
    25% {
        transform: translateY(-20px) translateX(10px);
    }
    50% {
        transform: translateY(-10px) translateX(-10px);
    }
    75% {
        transform: translateY(-30px) translateX(5px);
    }
`;

const pulse = keyframes`
    0%, 100% {
        opacity: 0.3;
        transform: scale(1);
    }
    50% {
        opacity: 0.8;
        transform: scale(1.2);
    }
`;

const BackgroundEffect = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 1;
    pointer-events: none;
`;

const Orb = styled.div`
    position: absolute;
    width: ${props => props.size};
    height: ${props => props.size};
    background: ${props => props.color};
    border-radius: 50%;
    filter: blur(60px);
    top: ${props => props.top};
    left: ${props => props.left};
    animation: ${float} ${props => props.duration}s ease-in-out infinite;
`;

const LineSvg = styled.svg`
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 1;
`;

const Particle = styled.div`
    position: absolute;
    width: 4px;
    height: 4px;
    background: linear-gradient(135deg, #9b59b6, #e74c3c);
    border-radius: 50%;
    animation: ${pulse} 3s ease-in-out infinite;
`;

export default Wave;
